import React from 'react';
import ZsFormikCheckbox from "src/components/atoms/zsCheckbox";
import {useField} from "formik";

export interface IEnergyTypeGasProps {
    electricityPossible: boolean;
    disableAutoselect: boolean;
    disabled: boolean;
}

export function EnergyTypeGas(props: IEnergyTypeGasProps) {

    const [{value}, __, {setValue}] = useField('energyTypeGas');

    React.useEffect(() => {
        if (props.disableAutoselect) {
            return;
        }
        if (!props.electricityPossible) {
            setValue(true);
        } else {
            setValue(false);
        }

    }, [props.electricityPossible]);

    return (
        <ZsFormikCheckbox label="Gas" name="energyTypeGas" disabled={props.disabled}/>
    );

}